const assets = {}

assets.install = (Vue) => {
  Vue.prototype.$assets = {
    favicon: require('@/assets/favicon.svg'),
    robot: require('@/assets/robot.png'),
    faviconWhite: require('@/assets/favicon-white.svg'),
    background: require('@/assets/background.png')
  }
}

export default assets